import PlayNow from './PlayNow.class.js'

export {
  // eslint-disable-next-line import/prefer-default-export
  PlayNow,
}
